import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PLAYERS_IN_DESK = 12;
export const defaultAvatar = 'img/defaultAvatar.png';
export var ETeam;
(function (ETeam) {
    ETeam["MAFIA"] = "MAFIA";
    ETeam["CIVILIANS"] = "CIVILIANS";
    ETeam["FOOLS"] = "FOOLS";
})(ETeam || (ETeam = {}));
export const TeamName = (team) => {
    switch (team) {
        case ETeam.CIVILIANS:
            return 'Мирные';
        case ETeam.MAFIA:
            return 'Мафия';
        case ETeam.FOOLS:
            return 'Дурак';
    }
    return '';
};
export var TMatchResultCase;
(function (TMatchResultCase) {
    TMatchResultCase["MAFIA_WIN"] = "MAFIA_WIN";
    TMatchResultCase["CIVILIANS_WIN"] = "CIVILIANS_WIN";
    TMatchResultCase["FOOLS_WIN"] = "FOOLS_WIN";
    TMatchResultCase["DRAW"] = "DRAW";
})(TMatchResultCase || (TMatchResultCase = {}));
export var ERoleTypes;
(function (ERoleTypes) {
    ERoleTypes["CIVILIAN"] = "CIVILIAN";
    ERoleTypes["MAFIA"] = "MAFIA";
    ERoleTypes["DON"] = "DON";
    ERoleTypes["SHERIFF"] = "SHERIFF";
    ERoleTypes["DOCTOR"] = "DOCTOR";
    ERoleTypes["MANIAC"] = "MANIAC";
    ERoleTypes["LADY"] = "LADY";
    ERoleTypes["GAG"] = "GAG";
    ERoleTypes["SWITCHMAN"] = "SWITCHMAN";
    ERoleTypes["BOMB"] = "BOMB";
    ERoleTypes["JAILER"] = "JAILER";
    ERoleTypes["WEREWOLF"] = "WEREWOLF";
    ERoleTypes["KAMIKADZE"] = "KAMIKADZE";
    ERoleTypes["PROVOCATEUR"] = "PROVOCATEUR";
    ERoleTypes["WIFE"] = "WIFE";
    ERoleTypes["HUSBAND"] = "HUSBAND";
    ERoleTypes["FOOL"] = "FOOL";
    ERoleTypes["BACHELOR"] = "BACHELOR";
    ERoleTypes["ADVOCATE"] = "ADVOCATE";
    ERoleTypes["INSTIGATOR"] = "INSTIGATOR";
})(ERoleTypes || (ERoleTypes = {}));
export var TPlayerMatchStatus;
(function (TPlayerMatchStatus) {
    TPlayerMatchStatus[TPlayerMatchStatus["ALIVE"] = 0] = "ALIVE";
    TPlayerMatchStatus[TPlayerMatchStatus["DEAD"] = 1] = "DEAD";
})(TPlayerMatchStatus || (TPlayerMatchStatus = {}));
export var EPaymentType;
(function (EPaymentType) {
    EPaymentType[EPaymentType["UNKNOWN"] = 0] = "UNKNOWN";
    EPaymentType[EPaymentType["FREE"] = 1] = "FREE";
    EPaymentType[EPaymentType["BOT"] = 2] = "BOT";
    EPaymentType[EPaymentType["WIRE_TRANSFER"] = 3] = "WIRE_TRANSFER";
    EPaymentType[EPaymentType["CASH"] = 4] = "CASH";
    EPaymentType[EPaymentType["PAID_BY_OTHER_PLAYER"] = 5] = "PAID_BY_OTHER_PLAYER";
})(EPaymentType || (EPaymentType = {}));
export const getPaymentString = (p) => {
    switch (p) {
        case EPaymentType.WIRE_TRANSFER:
            return 'Перевод';
        case EPaymentType.BOT:
            return 'Бот';
        case EPaymentType.CASH:
            return 'Наличные';
        case EPaymentType.FREE:
            return 'Без оплаты';
        case EPaymentType.UNKNOWN:
            return 'Не выбран';
        case EPaymentType.PAID_BY_OTHER_PLAYER:
            return 'Другой игрок';
        default:
            return 'Не выбран';
    }
};
export const getRoleString = (role) => {
    switch (role) {
        case ERoleTypes.CIVILIAN:
            return 'Мирный';
        case ERoleTypes.MAFIA:
            return 'Мафия';
        case ERoleTypes.DON:
            return 'Дон';
        case ERoleTypes.SHERIFF:
            return 'Шериф';
        case ERoleTypes.DOCTOR:
            return 'Доктор';
        case ERoleTypes.MANIAC:
            return 'Маньяк';
        case ERoleTypes.LADY:
            return 'Императрица';
        case ERoleTypes.GAG:
            return 'Затычка';
        case ERoleTypes.SWITCHMAN:
            return 'Стрелочник';
        case ERoleTypes.BOMB:
            return 'Зараженный';
        case ERoleTypes.JAILER:
            return 'Тюремщик';
        case ERoleTypes.WEREWOLF:
            return 'Оборотень';
        case ERoleTypes.KAMIKADZE:
            return 'Камикадзе';
        case ERoleTypes.PROVOCATEUR:
            return 'Агент провокатор';
        case ERoleTypes.WIFE:
            return 'Жена';
        case ERoleTypes.HUSBAND:
            return 'Муж';
        case ERoleTypes.FOOL:
            return 'Дурак';
        case ERoleTypes.BACHELOR:
            return 'Холостяк';
        case ERoleTypes.ADVOCATE:
            return 'Адвокат';
        case ERoleTypes.INSTIGATOR:
            return 'Подстрекатель';
        default:
            return 'Мирный';
    }
};
// eslint-disable-next-line consistent-return
export const getRoleNightActionName = (role) => {
    // eslint-disable-next-line default-case
    switch (role) {
        case ERoleTypes.MAFIA:
            return ['Убить'];
        case ERoleTypes.DON:
            return 'Заблокировать';
        case ERoleTypes.MANIAC:
            return 'Убить';
        case ERoleTypes.WEREWOLF:
            return 'Убить';
        case ERoleTypes.SHERIFF:
            return 'Проверить';
        case ERoleTypes.DOCTOR:
            return 'Вылечить';
        case ERoleTypes.LADY:
            return 'Навестить';
        case ERoleTypes.GAG:
            return 'Заткнуть';
        case ERoleTypes.SWITCHMAN:
            return 'Убить';
        case ERoleTypes.BOMB:
            return 'Заразить';
        case ERoleTypes.PROVOCATEUR:
            return 'Спровоцировать';
        case ERoleTypes.JAILER:
            return 'Проверить';
        case ERoleTypes.ADVOCATE:
            return 'Обелить';
        case ERoleTypes.INSTIGATOR:
            return 'Очернить';
        case ERoleTypes.WIFE:
        case ERoleTypes.HUSBAND:
            return 'Ничего не делать с';
    }
};
// eslint-disable-next-line consistent-return
export const getRoleNightActionColor = (role) => {
    // eslint-disable-next-line default-case
    switch (role) {
        case ERoleTypes.MAFIA:
            return '#CC8181';
        case ERoleTypes.DON:
            return '#CC8181';
        case ERoleTypes.MANIAC:
            return '#CC8181';
        case ERoleTypes.WEREWOLF:
            return '#CC8181';
        case ERoleTypes.SHERIFF:
            return '#81CC96';
        case ERoleTypes.DOCTOR:
            return '#81CC96';
        case ERoleTypes.LADY:
            return '#81CC96';
        case ERoleTypes.GAG:
            return '#CC8181';
        case ERoleTypes.SWITCHMAN:
            return '#CC8181';
        case ERoleTypes.BOMB:
            return '#CC8181';
        case ERoleTypes.PROVOCATEUR:
            return '#CC8181';
        case ERoleTypes.JAILER:
            return '#81CC96';
        case ERoleTypes.ADVOCATE:
        case ERoleTypes.INSTIGATOR:
            return '#CC8181';
        case ERoleTypes.WIFE:
        case ERoleTypes.HUSBAND:
            return '#899295';
    }
};
export const getPhaseEventDescription = (type) => {
    switch (type) {
        case 'KILL':
        case 'VOTES_KILL':
        case 'EXPLODE':
        case 'FAMILY_KILL':
            return { name: 'Убит', color: 'red', icon: 'Cross.svg' };
        case 'REVOKE_IMMUNITY':
            return {
                name: (_jsxs("span", { children: ["\u0418\u043C\u043C\u0443\u043D\u0438\u0442\u0435\u0442", _jsx("br", {}), "\u0430\u043D\u043D\u0443\u043B\u0438\u0440\u0443\u0435\u0442\u0441\u044F"] })),
                color: 'green',
                icon: 'RemovedShield.svg',
            };
        case 'MAKE_SILENT':
            return {
                name: (_jsxs("span", { children: ["\u041F\u043E\u043B\u0443\u0447\u0430\u0435\u0442", _jsx("br", {}), "\u0437\u0430\u0442\u044B\u0447\u043A\u0443"] })),
                color: 'green',
                icon: 'Silence.svg',
            };
        case 'JAILER_ARREST':
            return {
                name: (_jsxs("span", { children: ["\u0421\u0430\u0434\u0438\u0442\u0441\u044F", _jsx("br", {}), "\u0432 \u0442\u044E\u0440\u044C\u043C\u0443"] })),
                color: 'green',
                icon: 'LockClose.svg',
            };
        case 'RELEASE_FROM_PRISON':
            return {
                name: (_jsxs("span", { children: ["\u0412\u044B\u0445\u043E\u0434\u0438\u0442", _jsx("br", {}), "\u0438\u0437 \u0442\u044E\u0440\u044C\u043C\u044B"] })),
                color: 'green',
                icon: 'LockOpen.svg',
            };
        case 'SAVED_BY_LADY':
            return { name: 'Спасён леди', color: 'green', icon: 'Lady.svg' };
        case 'TECH_KILL':
            return {
                name: (_jsxs("span", { children: ["\u0422\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0439", _jsx("br", {}), "\u0442\u0440\u0443\u043F"] })),
                color: 'red',
                icon: 'Cross.svg',
            };
        default:
            return { name: '', color: '', icon: '' };
    }
};
export var EEventPlayerStatus;
(function (EEventPlayerStatus) {
    EEventPlayerStatus[EEventPlayerStatus["ACTIVE"] = 0] = "ACTIVE";
    EEventPlayerStatus[EEventPlayerStatus["CANCELLED"] = 1] = "CANCELLED";
})(EEventPlayerStatus || (EEventPlayerStatus = {}));
export var ERoundDirection;
(function (ERoundDirection) {
    ERoundDirection["POSITIVE"] = "POSITIVE";
    ERoundDirection["NEGATIVE"] = "NEGATIVE";
})(ERoundDirection || (ERoundDirection = {}));
export var EPlayerGameStateKeys;
(function (EPlayerGameStateKeys) {
    EPlayerGameStateKeys["CAN_VOTE"] = "canVote";
    EPlayerGameStateKeys["IMMUNITY"] = "immunity";
    EPlayerGameStateKeys["MUTED"] = "muted";
    EPlayerGameStateKeys["MINED_BY"] = "minedBy";
    EPlayerGameStateKeys["IMPRISONED_BY"] = "imprisonedBy";
    EPlayerGameStateKeys["PROTECTED_BY_LADY"] = "protectedByLady";
})(EPlayerGameStateKeys || (EPlayerGameStateKeys = {}));
export var EPlayerGameStateKeysPublic;
(function (EPlayerGameStateKeysPublic) {
    EPlayerGameStateKeysPublic["MUTED"] = "muted";
    EPlayerGameStateKeysPublic["IMPRISONED_BY"] = "imprisonedBy";
})(EPlayerGameStateKeysPublic || (EPlayerGameStateKeysPublic = {}));
export var EPlayerGameStateKeysPrivate;
(function (EPlayerGameStateKeysPrivate) {
    EPlayerGameStateKeysPrivate["IMMUNITY"] = "immunity";
    EPlayerGameStateKeysPrivate["MINED_BY"] = "minedBy";
    EPlayerGameStateKeysPrivate["PROTECTED_BY_LADY"] = "protectedByLady";
})(EPlayerGameStateKeysPrivate || (EPlayerGameStateKeysPrivate = {}));
// затычка и тюрьма публично
// остальные скрыть/показать
export const getPlayerGameStateString = (state, players) => {
    const out = {};
    out[EPlayerGameStateKeys.IMMUNITY] = ((state === null || state === void 0 ? void 0 : state[EPlayerGameStateKeys.IMMUNITY]) && 'Иммунитет') || '';
    out[EPlayerGameStateKeys.MUTED] = ((state === null || state === void 0 ? void 0 : state[EPlayerGameStateKeys.MUTED]) && 'Затычка') || '';
    out[EPlayerGameStateKeys.MINED_BY] = ((state === null || state === void 0 ? void 0 : state[EPlayerGameStateKeys.MINED_BY]) && `Заражен`) || '';
    out[EPlayerGameStateKeys.IMPRISONED_BY] = ((state === null || state === void 0 ? void 0 : state[EPlayerGameStateKeys.IMPRISONED_BY]) && 'В тюрьме') || '';
    out[EPlayerGameStateKeys.PROTECTED_BY_LADY] =
        ((state === null || state === void 0 ? void 0 : state[EPlayerGameStateKeys.PROTECTED_BY_LADY]) && `Защищен леди`) || '';
    return out;
};
